export default {
    pages: {
        '109 - MCG': [
            {
                id: '113817', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 2
                    },
                    {
                        name: 'sprite_select_index',
                        value: 3
                    },

                ]
            }
        ],
        '110 - MCG': [
            {
                id: '113860', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 3
                    },

                ]
            },
            {
                id: '113885', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 3
                    },

                ]
            },
            {
                id: '113886', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 2
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },

                ]
            },
            {
                id: '113887', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 3
                    },

                ]
            },
            {
                id: '226422', // button_node.
                attributes: [
                    {
                        name: 'sprite_initial_index',
                        value: 1
                    },
                ]
            }
        ],
        204: [
            {
                id: '112851', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128330', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128331', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128332', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128333', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128334', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128335', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128336', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128337', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '128338', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            }
        ],
        '714 - MCG': [
            {
                id: '126533', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '126534', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '126535', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
            {
                id: '126536', // graphic_answers_node.
                attributes: [
                    {
                        name: 'sprite_hover_index',
                        value: 3
                    },
                    {
                        name: 'sprite_select_index',
                        value: 2
                    },
                ]
            },
        ],

    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.PLPO.3.1.0.js